import { AsyncPipe, NgFor, NgIf } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnDestroy, OnInit } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { CustomisableSection } from '@shared/models/customisable-section';
import { MenuList } from '@shared/models/menu-list';
import { CustomImagePipe } from '@shared/pipes/custom-image.pipe';
import { SafeHtmlPipe } from '@shared/pipes/safe-html.pipe';
import { SiteSettingsService } from '@shared/services/site-settings.service';
import { AccessibleClickDirective } from '@shared/shared/directives/accessible-click.directive';
import { ISiteSettings } from '@shared/shared/interfaces/site-settings.interfaces';
import { CustomisableSectionsService } from '@shared/shared/services/customisable-sections.service';
import { USER_LOCAL_STORAGE_KEY } from 'app.config';
import { NavigationService } from 'core/services/navigation.service';
import { Observable, Subject, combineLatest, distinctUntilChanged, filter, takeUntil } from 'rxjs';
import { map } from 'rxjs/operators';

@Component({
  selector: 'ten-mtls-footer',
  templateUrl: './mtls-footer.component.html',
  styleUrls: ['./mtls-footer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    NgFor,
    AsyncPipe,
    SafeHtmlPipe,
    CustomImagePipe,
    NgIf,
    RouterModule,
    AccessibleClickDirective,
    TranslateModule,
  ],
})
export class MtlsFooterComponent implements OnInit, OnDestroy {
  public onDestroy$ = new Subject<void>();
  public footerMenuList$: Observable<MenuList[]>;
  public footerSection$: Observable<CustomisableSection>;
  public showPlatformProvider = false;
  public platformProviderType = '';
  public isAccessHrt: boolean;
  public footerContent = '';

  constructor(
    private siteSettingsService: SiteSettingsService,
    private customisableSectionsService: CustomisableSectionsService,
    private navigationService: NavigationService,
    private router: Router
  ) {}

  public ngOnInit(): void {
    const isUserLoggedIn = !!localStorage.getItem(USER_LOCAL_STORAGE_KEY);
    this.siteSettingsService
      .fetchSiteSettings()
      .pipe(
        filter((value) => value !== null),
        takeUntil(this.onDestroy$),
        distinctUntilChanged()
      )
      .subscribe((data: ISiteSettings) => {
        this.showPlatformProvider = data.fe_configuration.show_platform_provider_nav;
        this.platformProviderType = data.fe_configuration.platform_provider_type;
        this.isAccessHrt = data.switches.access_to_HTR;
      });

    if (!isUserLoggedIn) {
      this.footerMenuList$ = combineLatest([
        this.navigationService.getNavigationLinks('content-outside-footer'),
        this.navigationService.getNavigationLinks('footer'),
      ]).pipe(
        map(([contentOutside, footer]) => {
          return [...contentOutside, ...footer];
        })
      );
    } else {
      this.footerMenuList$ = this.navigationService.getNavigationLinks('footer');
    }

    this.footerSection$ = this.customisableSectionsService
      .getCustomisableSection('footercontent')
      .pipe(takeUntil(this.onDestroy$));
  }

  public navigate(link: string) {
    this.router.navigate([link]);
  }

  public ngOnDestroy(): void {
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }
}
